import React from 'react';
import { Link } from 'react-router-dom';

const AuthPromptModal = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <button
        type="button"
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onClose}
        aria-label="Close"
      />
      <div className="relative w-full max-w-md rounded-2xl bg-white p-8 shadow-2xl text-center">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Sign in to continue</h2>
        <p className="text-gray-600 mb-6">
          Create an account or log in to view artwork analytics, graphs, and gallery tools.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/login"
            className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-800 font-medium hover:bg-gray-50 transition"
            onClick={onClose}
          >
            Log in
          </Link>
          <Link
            to="/signup"
            className="px-6 py-2.5 rounded-lg bg-blue-600 text-white font-medium hover:bg-blue-700 transition"
            onClick={onClose}
          >
            Sign up
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AuthPromptModal;
